import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import './CreateAccountForm.css';

import { changeCreateAccountFormStatus, changeNewAccountBranchId, changeNewAccountType, changeNewAccountUserId, clearCreateAccountForm, createAccount, createAccountFormIsActive, createAccountStatus, selectConfirmingCreateAccount, selectCreateAccountFormAccountType, selectCreateAccountFormBranchId, selectCreateAccountFormUserId, selectCreatedAccount, setConfirmingCreateAccount, toggleCreateAccountForm } from "./createAccountFormSlice";
import { loadBranches, selectBranches } from "../manageBranches/branchesSlice";
import { loadUsers, selectUsers } from "../manageUsers/manageUsersSlice";
import ConfirmAction from "../../components/confirmAction/ConfirmAction";
import { addAccount } from "../manageAccounts/accountsSlice";
import { selectUser } from "../home/userSlice";
import { selectToken } from "../login/loginSlice";

export default function CreateAccountForm() {
    const dispatch = useDispatch();

    const token = useSelector(selectToken);

    const createAccountFormActive = useSelector(createAccountFormIsActive);
    const statusMessage = useSelector(createAccountStatus);

    const branches = useSelector(selectBranches);
    const users = useSelector(selectUsers);
    const createAccountFormBranchId = useSelector(selectCreateAccountFormBranchId);
    const createAccountFormUserId = useSelector(selectCreateAccountFormUserId);
    const createAccountFormAccountType = useSelector(selectCreateAccountFormAccountType);
    const confirmingCreateAccount = useSelector(selectConfirmingCreateAccount);
    const createdAccount = useSelector(selectCreatedAccount);

    const userInfo = useSelector(selectUser);
    const bankId = userInfo.bankId;
    const display = createAccountFormActive ? "flex" : "none";

    useEffect(() => {
        if (createAccountFormActive) {
            dispatch(loadUsers({bankId, token}))
            dispatch(loadBranches({bankId, token}))
        }
    }, [dispatch, createAccountFormActive, bankId, token])

    useEffect(() => {
        dispatch(addAccount(createdAccount));
    }, [dispatch, createdAccount])

    const handleBranchIdChange = (event) => {
        dispatch(changeNewAccountBranchId(event.target.value));
    }

    const handleUserIdChange = (event) => {
        dispatch(changeNewAccountUserId(event.target.value));
    }

    const handleAccountTypeChange = (event) => {
        dispatch(changeNewAccountType(event.target.value));
    }

    const handleCancelButtonClick = (event) => {
        event.preventDefault();
        dispatch(toggleCreateAccountForm());
        dispatch(clearCreateAccountForm());
    }

    const handleConfirmCancelClick = () => {
        dispatch(setConfirmingCreateAccount(false));
    }

    const handleCreateAccountButtonClick = (event) => {
        event.preventDefault();
        if (createAccountFormBranchId === 'blank') {
            dispatch(changeCreateAccountFormStatus('Please select a branch'));
        } else if (createAccountFormUserId === 'blank') {
            dispatch(changeCreateAccountFormStatus('Please select a user'));
        } else {
            dispatch(setConfirmingCreateAccount(true));
        }
    }

    const handleConfirmCreateClick = () => {
        const newAccount = {
            bankId: bankId,
            branchId: createAccountFormBranchId,
            username: createAccountFormUserId,
            accountType: createAccountFormAccountType
        }
        dispatch(createAccount({newAccount, token}));
        dispatch(clearCreateAccountForm());
        dispatch(setConfirmingCreateAccount(false));
        dispatch(loadBranches({bankId, token}))
    }

    return (
        <form className="form" style={{display: display, flexDirection: 'column'}}>
            <h3>Create Account</h3>
            <label htmlFor="branchId">
                Branch:
                <select onChange={handleBranchIdChange} value={createAccountFormBranchId}>
                    <option value={'blank'}>- select -</option>
                    {branches.map(branch => {
                        return <option value={branch.branchId} key={branch.branchId}>{branch.branchName}</option>
                    })}
                </select>
            </label>
            <label htmlFor="userId">
                User:
                <select onChange={handleUserIdChange} value={createAccountFormUserId}>
                    <option value={'blank'}>- select -</option>
                    {users.map(user => {
                        if (createAccountFormBranchId === 'blank' || createAccountFormBranchId === user.branchId) {
                            if (user.userRole === 'USER') {
                                return <option value={user.username} key={user.username}>{user.username} | {user.name}</option>
                            } else {
                                return ""
                            }
                        } else {
                            return "";
                        }
                    })}
                </select>
            </label>
            <label htmlFor="accountType">
                Account Type:
                <select onChange={handleAccountTypeChange} value={createAccountFormAccountType}>
                    <option value={'CHECKING'}>CHECKING</option>
                    <option value={'SAVINGS'}>SAVINGS</option>
                </select>
            </label>
            {!statusMessage ? "" : 
                <p className={statusMessage === 'Account successfully created' ? 'confirmation' : 'error'}>{statusMessage}</p>
            }
            <div className="button-container">
                <button onClick={handleCancelButtonClick}>Cancel</button>
                <button onClick={handleCreateAccountButtonClick}>Create New Account</button>
            </div>
            {confirmingCreateAccount ? <ConfirmAction handleCancel={handleConfirmCancelClick} handleConfirm={handleConfirmCreateClick}/> : ""}
        </form>
    )
}